import { render, staticRenderFns } from "./action-header.vue?vue&type=template&id=1adb844d"
import script from "./action-header.vue?vue&type=script&lang=ts"
export * from "./action-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports